import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import helpMapping from "../../config/data/helpMapping.json";

const HelpButton = ({
  currentStep,
  style = {},
  size = "middle",
  type = "text",
}) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [detectedStep, setDetectedStep] = useState(null);

  const getHelpInfo = () => {
    const activeStep = currentStep || "detectedStep";

    if (activeStep) {
      const stepPath = `${currentPath}/step/${activeStep}`;
      if (helpMapping.helpMapping[stepPath]) {
        return helpMapping.helpMapping[stepPath];
      }
    }

    //exact path match
    if (helpMapping.helpMapping[currentPath]) {
      return helpMapping.helpMapping[currentPath];
    }

    //match parent paths
    const pathParts = currentPath.split("/").filter(Boolean);
    for (let i = pathParts.length; i > 0; i--) {
      const partialPath = "/" + pathParts.slice(0, i).join("/");
      if (helpMapping.helpMapping[partialPath]) {
        return helpMapping.helpMapping[partialPath];
      }
    }

    return helpMapping.defaultHelp;
  };

  const helpInfo = getHelpInfo();

  const handleHelpClick = () => {
    window.open(helpInfo.url, "_blank", "noopener,noreferrer");
  };

  return (
    <Tooltip
      title={helpInfo.title || "View Help Documentation"}
      placement="bottom"
    >
      <Button
        type={type}
        size={size}
        icon={<QuestionCircleOutlined />}
        onClick={handleHelpClick}
        style={{
          color: "#666",
          border: "none",
          backgroundColor: "transparent",
          ...style,
        }}
      >
        Help
      </Button>
    </Tooltip>
  );
};

export default HelpButton;
